const SearchActionTypes = {
    SEARCH_CLICKED: 'SEARCH_CLICKED',
    ADD_DATES: 'ADD_DATES'
};

export default SearchActionTypes;
